import React from 'react';
import { DarkScreenMask, ImagePicker } from "@myplay/ui";

import './ImagePickerModal.scss';

const ImagePickerModal = ({ img, onSave, onCancel })=> {
  
  return (
    <DarkScreenMask isVisible={!!img} data-testid="image-picker-modal">
      <ImagePicker img={img} handleSave={onSave} handleCancel={onCancel}/>
    </DarkScreenMask> 
  );  
};

export default ImagePickerModal;